import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table7Data = { [key: string]: Table7Row }
export type Table7Row = {
  totalAllAccidents: number;
  totalAlcoholInvolved: number;
  fatalAllAccidents: number;
  fatalAlcoholInvolved: number;
  injuryAAllAccidents: number;
  injuryAAlcoholInvolved: number;
  injuryBCAllAccidents: number;
  injuryBCAlcoholInvolved: number;
}
export interface ITable7ClassProps {
  data: any;
}

interface ITable7State { }

const initialState: ITable7State = {};

const sortOrder = [
  "14 and younger",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25-34",
  "35-44",
  "45-54",
  "55-64",
  "65-74",
  "75 and older",
  "Age not stated",
];

export default class Table7 extends React.Component<ITable7ClassProps, ITable7State> {
  public constructor(props: any) {
    super(props);
    this.state = initialState;
  };

  public render() {
    return (
      <React.Fragment>
        {!this.props.data && (
          <p>Loading....</p>
        )}
        {this.props.data && (
          <table className="ss-table summaryTable1">
            <thead>
              <tr>
                <th rowSpan={2} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">7</span>
                    <span className="header-text">AGE OF DRIVER</span>
                  </div>
                </th>
                <th colSpan={2}>TOTAL</th>
                <th colSpan={2}>FATAL</th>
                <th colSpan={2}>INJURY A*</th>
                <th colSpan={2}>INJURY B* and C*</th>
              </tr>
              <tr>
                <th>ALL CRASHES</th>
                <th>ALCOHOL INVOLVED</th>
                <th>ALL CRASHES</th>
                <th>ALCOHOL INVOLVED</th>
                <th>ALL CRASHES</th>
                <th>ALCOHOL INVOLVED</th>
                <th>ALL CRASHES</th>
                <th>ALCOHOL INVOLVED</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key) =>
                <tr key={key} className={key === "TOTALS" ? "border-bold bold-text" : null}>
                  <td className="border-right-bold">{key}</td>
                  <td className="numberTotals">{this.props.data[key].totalAllAccidents}</td>
                  <td className="numberTotals">{this.props.data[key].totalAlcoholInvolved}</td>
                  <td className="numberTotals">{this.props.data[key].fatalAllAccidents}</td>
                  <td className="numberTotals">{this.props.data[key].fatalAlcoholInvolved}</td>
                  <td className="numberTotals">{this.props.data[key].injuryAAllAccidents}</td>
                  <td className="numberTotals">{this.props.data[key].injuryAAlcoholInvolved}</td>
                  <td className="numberTotals">{this.props.data[key].injuryBCAllAccidents}</td>
                  <td className="numberTotals">{this.props.data[key].injuryBCAlcoholInvolved}</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </React.Fragment>
    );
  }
}
